//This file is used to configure cometd and define its related functions for subscribing and publishing
// Imports section
// import HWUser from "../Simplify360Chat/HWLibrary/HWUser";
// import uuid from "react-uuid";
// import { isNullOrUndefined } from "../Simplify360Chat/HWLibrary/HWUtils";
// import { s360ConfigService } from "../Simplify360Chat/Services/S360Config";

let isConnected = false;
let recieveURLGlobal;
let subscription;
let listOfComponentsToUpdate;
let refElementGlobal;

export const cometdSubscribe = (refElement, listenChannel, cometd, appComponent) => {
  // var network = navigator.onLine ? "online" : "offline";
  //Variable declaration
  refElementGlobal = refElement;
  listOfComponentsToUpdate = ["ConversationPage", "LandingPage"];

  //   let listOfComponentsToUpdate = ["ConversationPage","LandingPage"];
  // let connectionURL = "https://devdata.simplify360.com/bmcometd/cometd";
  // let sendURl = "/cometd-server-channel";
  let recieveURL = `/${listenChannel}`;
  console.log(recieveURL,"RECIEVE URL");
  recieveURLGlobal = recieveURL;
  let secureCometdToken = localStorage.getItem("cometdToken");
  let secureCometdUser = localStorage.getItem("cometdUser");
  let additional = {
    ext: {
      "com.inrev.authn": {
        user: !!secureCometdUser && secureCometdUser !== 'undefined' ? secureCometdUser : "cometuser1",
        token: !!secureCometdToken && secureCometdToken !== 'undefined' ? secureCometdToken : "adfwew283292"
      }
    },
  };

  return new Promise((resolve, reject) => {
    // cometd handshake
    cometd.handshake(additional, function (handshakeReply) {
      if (handshakeReply.successful) {
        console.log("COMETD-LOG: HANDSHAKE SUCCESSFULL", refElement)
        subscription = cometd.batch(function () {
          cometd.subscribe(
            recieveURL,
            function (message) {
              if (message) {
                console.log("COMETD-LOG: EVENT TRIGGERED", message);
                let customEvent = new CustomEvent("updateComponent", {
                  detail: {
                    componentsToUpdate: listOfComponentsToUpdate,
                    data: {
                      message,
                      /* data to be used from events received can be used for manipulating the component or any required funtion */
                    },
                  },
                  bubbles: true,
                }); /* Dispatch the CustomEvent to the ref element from where it will be triggered */
      
                console.log("subscribed from cometd");
                refElement.current.dispatchEvent(customEvent);
                console.log("COMETD-LOG-CHECK: 1 service");
              }
            },
            function (ack) {
              if (ack.successful) {
                console.log("COMETD-LOG: RECIEVE CHANNEL SUBSCRIBED", refElement);
              }
            }
          );
        })
        isConnected = true;
        resolve("COMETD-LOG: HANDSHAKE SUCCESSFULL")
      } else {
        // TODO: improvement ::: check into handleShowReloadPopup
        // console.log("failed in service", appComponent);
        // appComponent.actions.handleShowReloadPopup();
        reject("COMETD-LOG:HANDHSAKE FAILED");
      }
    });
  })
}

// FIXME: sample handler for /meta/connect
const handleConnect = (message) => {
  if (message.successful) {
    console.log('Connection is alive');
  } else {
    console.warn('Connection lost')
    // TODO: handle reconnection or notify user
  }
}

// FIXME:
export const reConnectCometd = (cometd) => {
  console.log("TRYING TO RECONNECT ")
  subscription && cometd.unsubscribe(subscription);

  subscription = cometd.subscribe(
    recieveURLGlobal,
    function (message) {
      if (message) {
        let customEvent = new CustomEvent("updateComponent", {
          detail: {
            componentsToUpdate: listOfComponentsToUpdate,
            data: {
              message,
              /* data to be used from events received can be used for manipulating the component or any required funtion */
            },
          },
          bubbles: true,
        }); 
        /* Dispatch the CustomEvent to the ref element from where it will be triggered */
        console.log("RE-SUBSCRIBING TO CLIENT CHANNEL AGAIN", recieveURLGlobal);
        refElementGlobal.current.dispatchEvent(customEvent);
        // console.log("COMETD-LOG-CHECK: 1 service");
      }
    },
    function (ack) {
      if (ack.successful) {
        console.log("COMETD-LOG: RECIEVE CHANNEL SUBSCRIBED", refElementGlobal);
      }
    }
  );
}
